import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-gr",
  "use": "icon-flag-gr-usage",
  "viewBox": "0 0 1568 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1568 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-gr\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 0h1555.872v1024H0z\" fill=\"#0D5EAF\" p-id=\"6365\" /><path d=\"M583.456 146.272h972.416v97.536H583.456v-97.536zM0 243.808h583.456v97.536H0v-97.536z\" fill=\"#FFFFFF\" p-id=\"6366\" /><path d=\"M243.104 0h97.248v585.152h-97.248V0z m340.352 341.344h972.416v97.536H583.456v-97.536zM0 585.152h1555.872v97.536H0v-97.536z m0 207.232h1555.872v97.536H0v-97.536z\" fill=\"#FFFFFF\" p-id=\"6367\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-gr.svg
// module id = IKMD
// module chunks = 24